<app-modal-base [title]="dialogTitle" (onSubmitEvent)="onSubmit()" [loading]="isLoading" cancelType="CANCEL"
  [isDisabled]="form.invalid ">
  <ng-container main *ngTemplateOutlet="content"></ng-container>
</app-modal-base>

<ng-template #content>
  <div mat-dialog-content>
    <p *ngIf="data.category">
      Catégorie: {{ categoryName }}
    </p>
    <div class="formContainer d-flex justify-content-center">
      <form [formGroup]="form">
        <!-- list -->
        <span *ngIf="documents.length>0; else noData">
          <ul formArrayName="documents">
            <li *ngFor="let item of documents">
              <mat-checkbox (change)="onClickDocument($event, item)" [disabled]="docsDisabled[item.uid]">{{item.name}}
              </mat-checkbox>
            </li>
          </ul>
        </span>
      </form>
    </div>
  </div>
</ng-template>

<ng-template #noData>
  <div *ngIf="!isLoading">
    <ng-container *ngIf="this.data.category">
      Aucun document n'est disponible dans la catégorie {{ categoryName }}.
    </ng-container>
    <ng-container *ngIf="!this.data.category">
      Aucun document n'est disponible.
    </ng-container>

  </div>
</ng-template>